/**
 * External dependencies
 */
export const getSearchedResults = (state) => {
    return state.results;
}
export const getResults = (state) =>{
    return state.results;
}
export const getCategories = ( state) =>{
    return state.categories;
}

export const getLastQuery = (state) =>{
    return state.lastQuery;
}